<template>
  <div class="topic">

    <div id="main" class="wh1200">
      <div class="crumbs">
        <div class="name">您现在所在位置：</div>
        <div class="crumbs_box">
          <a href="/">首页</a>
          <a href="/newslistphoto">新闻中心</a>
          <a href="/topic">专题新闻</a>
        </div>
      </div>
      <div class="list_content">
        <div class="list_link">
          <div class="home_title"><span class="left">新闻中心</span></div>
          <div class="link_box">
            <a @click="headerClick()">头条新闻</a>
            <a @click="photoClick()">图文新闻</a>
            <a @click="special()" class="active">专题新闻</a>
            <!-- class="active" -->
          </div>
        </div>
        <div class="new_content zhuanti_content">
          <ul class="new_list">
            <li v-for="item in list" :key="item">
              <a href="javascript:;" class="new_name" @click="pages(item.special_id)">{{item.title}}</a>
              <div class="new_text">
                <p style="
			    overflow: hidden;
			    text-overflow: ellipsis;
			    display: -webkit-box;
			    -webkit-line-clamp: 3;
			    -webkit-box-orient: vertical;">{{item.content}}</p>
                [<a href="javascript:;" @click="pages(item.special_id)">查看详情</a>]
              </div>
              <div class="new_bottom">
                <div class="time"><img src="../../static/time_icon.png" alt="">{{item.time}}</div>
                <a href="javascript:;" class="come_in" @click="pages(item.special_id)">进入专题</a>
              </div>
            </li>
          </ul>
          <pages @changPage="changPage" :count="count"></pages>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import pages from '@/components/pages'
import news from '@/api/modules/news'
export default {
  data () {
    return {
      count: 1,
      sendFrom: {
        'pageSize': '10',
        'page': '1'
      },
      list: []
    }
  },
  components: {
    pages
  },
  created () {
    this.init()
  },
  methods: {
    changPage (index) {
      this.sendFrom.page = index
      this.init()
    },

    pages (id) {
      this.$router.push({
        path: '/topicont',
        query: {
          'id': id
        }
      })
    },

    init () {
      axios({
        method: 'post',
        url: news.topic,
        data: this.sendFrom
      }).then(res => {
        this.count = Number.parseInt(Math.ceil(res.data.count / 10))
        this.list = res.data.list
      })
    },
    headerClick () {
      this.sendFrom.types = 10
      this.init()
      this.$router.push({
        path: '/newslist'
      })
    },
    photoClick () {
      // this.sendFrom.types = 20
      // this.init()
      this.$router.push({
        path: '/newslistphoto'
      })
    },
    special () {
      this.$router.push({
        path: '/topic'
      })
    }
  }
}

</script>
<style scoped>
  @import '../../style/public';
  @import '../../style/comm';
   a{
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/news/topic.vue